module.exports = __webpack_public_path__ + "img/bg_992.28c8cd3e.png";